<template>
  <div>
    <common-dialog
      ref="dialog"
      width="360px"
      show-save-button
      title="维护考试结果"
      edit-title
      id-key="ExamId"
      :data="data"
      form-label-width="80px"
      :form-rules="rules"
      :save-func="api.Submit"
      :get-data-func="api.info"
      close-on-saved
      @edit-opened="onEditOpened"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
         <el-row class="row-border">
            <el-col :span="24">
              <el-form-item label="学员姓名" prop="FullName">
                {{data.FullName}}
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="学员性别" prop="Sex">
                {{data.Sex==1?'男':'女'}}
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="证件号码" prop="CertNo">
                {{data.CertNo}}
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="培训车型" prop="CarType">
                {{data.CarType}}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="考试科目" prop="Subject">
              {{data.Subject}}
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="考试类别" prop="ExamCategory">
                {{data.ExamCategory}}
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="申请时间" prop="ApplyTime">
                {{$commonJs.toDateString(data.ApplyTime)}}
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="考试时间" prop="ExamDate">
                <el-date-picker v-model="data.ExamDate" placeholder="请选择日期" @change="datePick" 
                value-format="yyyy-MM-dd" :picker-options="pickerOptions"  />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="考试结果" prop="Result">
                <el-select v-model="data.Result" placeholder="请选择类型" @change="resultChange" clearable>
                  <el-option label="通过" :value="1"></el-option>
                  <el-option label="不通过" :value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
         </el-row>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        ExamId: "",
        FullName: "",
        CertNo: "",
        CarType: "",
        Subject: "",
        ExamCategory: "",
        ExamDate: "",
        Result: null,
        Score: "",
        ApplyTime: "",
      },
      api: require("@/api/st/exam").default,
      rules: {
        // Result: [{ required: true, message: "请选择考试结果" }],
        ExamDate: [{ required: true, message: "请选择考试时间" }],
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
    };
  },
  methods: {
    onEditOpened(data) {
      if(data.Result === 0) {
        this.data.Result = null;
      }
    },
    resultChange(v) {
      if(!v) {
        this.data.Result = null;
      }
    },
    datePick(v) {
      if(v < this.data.ApplyTime) {
        this.$message.error("考试时间需大于申请时间");
        this.data.ExamDate = "";
      }
    }
  }
};
</script>